export default "__VITE_ASSET__920fdabb__"